export const clearAllServiceWorkerCache = async () => {
	const cacheNames = await caches.keys()

	return Promise.all(
		cacheNames.map(cache => caches.delete(cache))
	)
}